import { getTextFieldMaskProps, type TextFieldMaskPreset, type TextFieldProps } from "@wayflyer/flyui";
import { defineMessages, type IntlShape } from "react-intl";

const messages = defineMessages({
  usEin: {
    id: "identifier input: US EIN guidance",
    defaultMessage: "9-digit EIN/FEIN",
  },
  usSsn: {
    id: "identifier input: US SSN guidance",
    defaultMessage: "9-digit SSN",
  },
  auAbn: {
    id: "identifier input: AU ABN guidance",
    defaultMessage: "11-digit ABN",
  },
  beNationalRegister: {
    id: "identifier input: BE national register guidance",
    defaultMessage: "11-digit Belgian National Register number",
  },
  dkCpr: {
    id: "identifier input: DK CPR guidance",
    defaultMessage: "10-digit CPR number",
  },
  dePersonalTaxId: {
    id: "identifier input: DE personal tax ID guidance",
    defaultMessage: "11-digit Steuer-Identifikationsnummer",
  },
  frFiscalNumber: {
    id: "identifier input: FR fiscal number guidance",
    defaultMessage: "13-digit Numéro Fiscal de Référence",
  },
  gbAccountNumber: {
    id: "identifier input: GB account number guidance",
    defaultMessage: "8-digit UK account number",
  },
});

const guidanceByPreset = {
  US_EIN: messages.usEin,
  US_EIN_REDACTED: messages.usEin,
  US_SSN: messages.usSsn,
  US_SSN_REDACTED: messages.usSsn,
  AU_ABN: messages.auAbn,
  BE_NATIONAL_REGISTER: messages.beNationalRegister,
  DK_CPR: messages.dkCpr,
  DE_PERSONAL_TAX_ID: messages.dePersonalTaxId,
  FR_FISCAL_NUMBER: messages.frFiscalNumber,
  GB_ACCOUNT_NUMBER: messages.gbAccountNumber,
} satisfies Record<TextFieldMaskPreset, (typeof messages)[keyof typeof messages]>;

export const getIdentifierInputProps = (
  intl: IntlShape,
  configuration: Pick<TextFieldProps, "mask" | "helperText" | "placeholder"> & { maskPreset?: TextFieldMaskPreset }
): Pick<TextFieldProps, "mask" | "helperText"> => {
  const { maskPreset } = configuration;
  return {
    mask: configuration.mask ?? (maskPreset ? getTextFieldMaskProps(intl, maskPreset).mask : undefined),
    // Explicit undefined preserves fields whose existing helper is conditional.
    helperText:
      "helperText" in configuration
        ? configuration.helperText
        : maskPreset
        ? intl.formatMessage(guidanceByPreset[maskPreset])
        : undefined,
  };
};
